import Service			from "./../../Libs/Service";
import _				from "lodash";

import { Project }		from "./Project";
import { Layout } 		from "./Layout";
import { Publisher } 	from "./Publisher";

let Version = new Service({

	Name: "Version",

	Events: {

		'Selected Project Changed': function() {

			let project = Project.Projects[Project.SelectedProject?.id];

			if (project && Project.isSelectedProjectLoaded()) {

				this.autoSelectVersion();

			} else {

				this.selectVersion(null);

			}

		},

		'Project Versions Loaded': function () {

			if (!Version.SelectedVersion && Project.SelectedProject) this.autoSelectVersion();

		},

		"Project Deleted": function(projectId) {

			_.each(this.Versions, version => {

				if (version['project_id'] === projectId) delete this.Versions[version.id];

			});

			delete this.VersionsByProject[projectId];
			delete this.VersionsByProjectByCodename[projectId];

		}

	},

	Actions: {

		'Versions': function(versions, data) {

			let sizeBefore = _.size(this.Versions);

			this.updateVersions(versions);

			if (sizeBefore === 0) Broadcast.call("Versions Loaded", [versions]);
			if (data.VersionsProjectId) Broadcast.call("Project Versions Loaded", [data.VersionsProjectId]);

		},

		'NewVersionCreated': function(versionId) {

			this.selectVersion(versionId);

		},

		'ProjectVersionsPreviews': function(versionPreviews) {

			_.each(versionPreviews, (versionPreviews, versionId) => {

				this.updateVersionPreviews(versionId, versionPreviews);

			});

		},

		'VersionsPreviewsByVersionByHash': function(versionsPreviewsByVersionByHash) {

			_.each(versionsPreviewsByVersionByHash, (versionPreviews, versionId) => {

				this.updateVersionPreviews(versionId, versionPreviews);

			});

		},

		'VersionPreviewCreated': function(data) {

			Broadcast.call("New Preview Created", [data.versionId]);

		},

		'VersionPreviewDeleted': function(data) {

			Broadcast.call("Preview Deleted", [data.previewId]);

		},

		'GlobalSearchVersions': function (data) {
			Broadcast.call("Global Search Results", [data]);
		}

	},

	init() {

		this.Versions = {};
		this.VersionsByProject = {};
		this.VersionsByProjectByCodename = {};

		this.VersionPreviewsByVersionByHash = {};

		this.SelectedVersion = null;

	},

	updateVersions(versions) {

		_.each(versions, (version, version_id) => {

			let existingVersion = this.Versions[version_id];

			if (!version) {

				this.deleteVersion(existingVersion);

				Broadcast.call("Version Deleted", [version_id]);

			} else {

				this.updateVersion(version);

			}

		});

	},

	deleteVersion(version) {

		if (!version) return;

		delete this.Versions[version.id];

		if (this.VersionsByProject[version.project_id]) delete this.VersionsByProject[version.project_id][version.id];
		if (this.VersionsByProjectByCodename[version.project_id]) delete this.VersionsByProjectByCodename[version.project_id][version.codename];

	},

	updateVersion(version) {

		let existingVersion = this.Versions[version.id];

		this.Versions[version.id] = version;

		if (!this.VersionsByProject[version.project_id]) this.VersionsByProject[version.project_id] = {};
		this.VersionsByProject[version.project_id][version.id] = version;

		if (version.codename) {

			if (!this.VersionsByProjectByCodename[version.project_id]) this.VersionsByProjectByCodename[version.project_id] = {};
			this.VersionsByProjectByCodename[version.project_id][version.codename] = version;

		}

		let copyFrom = _.find(_.keys(version.Tags), tag => tag.indexOf('copy-from-') === 0);

		if (copyFrom) version.baseVersionId = parseInt(copyFrom.replace('copy-from-', ''));

		if (!version.Tags.custom) version.baseVersionId = version.id;

		if (!version.options.endCardMarkers) version.options.endCardMarkers = [];

		if (this.SelectedVersion && this.SelectedVersion.id === version.id) this.SelectedVersion = version;

		if (!existingVersion) {

			if (version.project_id === Project.SelectedProject?.id) Broadcast.call("Selected Project Version Loaded");
			else Broadcast.call("Version Loaded");

		} else {

			if (existingVersion.title !== version.title) Broadcast.call("Version Renamed", [version]);
			else if (!existingVersion.Tags.hidden && version.Tags.hidden) Broadcast.call("Version Hided", [version]);
			else if (existingVersion.Tags.hidden && !version.Tags.hidden) Broadcast.call("Version Showed", [version]);
			else if (existingVersion.options.endCardMarkers.length !== version.options.endCardMarkers.length) Broadcast.call("Version End Card Markers Changed", [version]);
			else if (existingVersion.options.screenshotFileName !== version.options.screenshotFileName) Broadcast.call("Version Screenshot Changed", [version]);
			else Broadcast.call("Version Changed", [version]);

		}

	},

	updateVersionPreviews(versionId, versionPreviews) {

		delete this.VersionPreviewsByVersionByHash[versionId];

		_.each(versionPreviews, versionPreview => {

			if (!this.VersionPreviewsByVersionByHash[versionPreview["version_id"]]) this.VersionPreviewsByVersionByHash[versionPreview["version_id"]] = {};

			this.VersionPreviewsByVersionByHash[versionPreview["version_id"]][versionPreview["hash"]] = versionPreview;

			versionPreview.createDate = new Date(versionPreview["create_date"]);

		});

		Broadcast.call("Project Version Previews Changed", [versionId]);

	},

	autoSelectVersion() {

		let versionId = window.localStorage.getItem("selected-version-for-project-" + Project.SelectedProject.id);

		if (Version.Versions[versionId]) Version.selectVersion(parseInt(versionId));

		else if (_.values(Version.VersionsByProject[Project.SelectedProject.id])[0]) Version.selectVersion(_.values(Version.VersionsByProject[Project.SelectedProject.id])[0].id);

		else Version.selectVersion(null);

	},

	selectVersion(versionId) {

		let oldSelectedVersion = this.SelectedVersion;

		this.SelectedVersion = Version.Versions[versionId];

		if (this.SelectedVersion) window.localStorage.setItem("selected-version-for-project-" + this.SelectedVersion["project_id"], versionId);

		Broadcast.call("Selected Version Changed");

		if (!oldSelectedVersion || oldSelectedVersion.id !== this.SelectedVersion?.id) Layout.setVersion(versionId);

	},

	getVersionScreenshot(project, version) {

		if (version.options.screenshotFileName) return `url(project-assets/project-${project.id}/version-${version.id}/${version.options.screenshotFileName})`;
		else return `url(Images/Icons/EndCards/${project.templateProps.codename}.png)`;

	},

	canCopyVersion() {

		if (User.currentUser && User.currentUser.isAdmin) return true;
		if (Project.SelectedProject && Project.SelectedProject.options && Project.SelectedProject.options.disableNewVersionsCreation) return false;
		if (!Publisher || !Publisher.SelectedPublisher || Publisher.SelectedPublisher.options.DisableNewVersionsCreation) return false;
		return true;

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Version) Version = window.Version;
else window.Version = Version;

export { Version }

